import { useEffect } from "react";
import style from "../AddReview.module.scss";
import StarRating from "./StarRating";
import wrapperHOC from "@Utils/wrapperHOC";
//

const AddReviewForm2 = ({ review, setReview }: any) => {
  useEffect(() => {
    if (!review.rating_details) {
      setReview({ ...review, rating_details: {} });
    }
  }, []);

  const onRatingChange = (rating: any, key: string) => {
    setReview({ ...review, rating_details: { ...review.rating_details, [key]: rating } });
  };
  return (
    <div className={style.reviewForm}>
      <div className={style.fieldSet}>
        <div className={style.fieldLabel}>
          propertypage.reviewssection.addreview.addreviewform.form2instruction
          <span className={style.labelOptional}>
            propertypage.reviewssection.addreview.addreviewform.optional
          </span>
        </div>
        <div className={style.uspRating}>
          <span className={style.uspTitle}>
            propertypage.reviewssection.addreview.addreviewform.valueformoney
          </span>
          <StarRating
            showDisplay={false}
            starSize={22}
            onChange={(val: any) => onRatingChange(val, "value_for_money")}
            defaultRating={review?.rating_details?.value_for_money || 0}
          />
        </div>
        <div className={style.uspRating}>
          <span className={style.uspTitle}>
            propertypage.reviewssection.addreview.addreviewform.staffmanagement
          </span>
          <StarRating
            showDisplay={false}
            starSize={22}
            onChange={(val: any) => onRatingChange(val, "staff_and_Management")}
            defaultRating={review?.rating_details?.staff_and_Management || 0}
          />
        </div>
        <div className={style.uspRating}>
          <span className={style.uspTitle}>
            propertypage.reviewssection.addreview.addreviewform.internetwifi
          </span>
          <StarRating
            showDisplay={false}
            starSize={22}
            onChange={(val: any) => onRatingChange(val, "internet_and_wi_fi")}
            defaultRating={review?.rating_details?.internet_and_wi_fi || 0}
          />
        </div>
        <div className={style.uspRating}>
          <span className={style.uspTitle}>
            propertypage.reviewssection.addreview.addreviewform.socialexperience
          </span>
          <StarRating
            showDisplay={false}
            starSize={22}
            onChange={(val: any) => onRatingChange(val, "social_experience")}
            defaultRating={review?.rating_details?.social_experience || 0}
          />
        </div>
        <div className={style.uspRating}>
          <span className={style.uspTitle}>
            propertypage.reviewssection.addreview.addreviewform.cleaning
          </span>
          <StarRating
            showDisplay={false}
            starSize={22}
            onChange={(val: any) => onRatingChange(val, "cleaning")}
            defaultRating={review?.rating_details?.cleaning || 0}
          />
        </div>
        <div className={style.uspRating}>
          <span className={style.uspTitle}>
            propertypage.reviewssection.addreview.addreviewform.overallamenities
          </span>
          <StarRating
            showDisplay={false}
            starSize={22}
            onChange={(val: any) => onRatingChange(val, "overall_amentities")}
            defaultRating={review?.rating_details?.overall_amentities || 0}
          />
        </div>
        <div className={style.uspRating}>
          <span className={style.uspTitle}>
            propertypage.reviewssection.addreview.addreviewform.location
          </span>
          <StarRating
            showDisplay={false}
            starSize={22}
            onChange={(val: any) => onRatingChange(val, "localities")}
            defaultRating={review?.rating_details?.localities || 0}
          />
        </div>
      </div>
    </div>
  );
};
export default wrapperHOC(AddReviewForm2, {
  componentName: "AddReviewForm2-ReviewsSection",
  showForChina: true,
});
